import './style.css';
import { useMemo } from 'react';

function FinalDate(props) {
  const { finalDate } = props;
  const time = useMemo(
    () =>
      finalDate.toLocaleDateString('de-DE', {
        weekday: 'long',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }),
    [finalDate],
  );
  return <span className="date">{time}</span>;
}

export default FinalDate;
